const getImageAdPlacementBaseStyles = () => ({
  placementCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    position: 'relative',
    boxSizing: 'content-box',
    overflow: 'hidden',
    background: '#fff',
    margin: 'auto',

    '& .placement-card-content': {
      width: '100%',
      height: '100%',
    },
  },
  placementTextContainer: {
    margin: 16,
    fontSize: 10,
    lineHeight: '16px',
    color: '#0078d4',
    overflow: 'hidden',
    '&:hover': {
      color: '#004578',
    },
  },
  placementShortHeadline: {
    color: 'rgba(43, 43, 43, 0.8)',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    margin: '5px 0',
  },
  placementLongHeadline: {
    fontWeight: 600,
    lineHeight: '24px',
    fontSize: 20,
    overflow: 'hidden',
    color: 'rgba(43, 43, 43, 1)',
    margin: '5px 0 15px 0',
  },
  placementAdsLabel: {
    position: 'static !important',
    color: '#767676 !important',
    border: '1px solid #ddd !important',
    margin: '0 4px 0 0 !important',
    display: 'inline',
    opacity: '100% !important',
    maxHeight: 16,
    fontWeight: 600,
    lineHeight: 1,
    borderRadius: '6px !important',
  },
  placementDescription: {
    color: '#333',
    display: 'inline-block',
    fontSize: 13,
    flexGrow: 1,
    overflow: 'hidden',
  },
  placementCallToAction: {
    position: 'absolute',
    right: '4%',
    bottom: '3%',
    border: '1px solid rgba(209, 209, 209, 1)',
    background: 'rgba(255, 255, 255, 1)',
    height: 32,
    borderRadius: 4,
    padding: '5px, 12px, 5px, 12px',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: 'rgba(36, 36, 36, 1)',
  },
});

export const getImageAdPlacementStyles = (theme) => {
  const {
    placementCard,
    placementFinalUrl,
    ...baseStyles
  } = getImageAdPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      alignItems: 'flex-start',
      background: 'transparent',
      '& .card-parent': {
        width: '100%',
      },
      '& .placement-card-content': {
        width: '100%',
        display: 'block',
        overflow: 'hidden',
        boxSizing: 'border-box',
      },
    },

    placementFinalUrl: {
      ...placementFinalUrl,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
  return styles;
};

export const getImageAdPlacementWithImageAsBackgroundStyles = (theme) => {
  const {
    placementCard = {},
    placementShortHeadline = {},
    placementLongHeadline = {},
    placementAdsLabel = {},
    ...baseStyles
  } = getImageAdPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      alignItems: 'flex-start',
      background: 'transparent',
      '& .card-parent': {
        width: '100%',
      },
      '& .placement-card-content': {
        width: '100%',
        display: 'block',
        overflow: 'hidden',
        boxSizing: 'border-box',
        '& .cropped-image-view': {
          overflow: 'unset !important',
        },
      },
    },
    placementGradient: {
      backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 32.81%, rgba(0, 0, 0, 0.55) 75.52%, rgba(0, 0, 0, 0.65) 100%)',
    },
    placementShortHeadline: {
      ...placementShortHeadline,
      color: '#FFFFFF',
      position: 'absolute',
      left: '5%',
      top: '55%',
    },
    placementLongHeadline: {
      ...placementLongHeadline,
      color: '#FFFFFF',
      position: 'absolute',
      left: '5%',
      top: '65%',
    },
    placementAdsLabel: {
      ...placementAdsLabel,
      color: '#FFFFFF !important',
      background: 'transparent !important',
      position: 'absolute',
      left: '5%',
      top: '90%',
    },
    adInfoLabel: {
      color: '#00AECD',
      position: 'absolute',
      right: '5%',
      top: '90%',
    },
  };
  return styles;
};

export const getImageAdPlacementWithPlayIconStyles = (theme) => {
  const {
    placementCard = {},
    placementAdsLabel = {},
    ...baseStyles
  } = getImageAdPlacementBaseStyles(theme);
  const styles = {
    ...baseStyles,

    placementCard: {
      ...placementCard,
      // padding: '8px 16px',
      alignItems: 'flex-start',
      background: 'transparent',
      '& .card-parent': {
        width: '100%',
      },
      '& .placement-card-content': {
        width: '100%',
        display: 'block',
        overflow: 'hidden',
        boxSizing: 'border-box',
        '& .cropped-image-view': {
          overflow: 'unset !important',
        },
      },
    },
    placementGradient: {
      backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 32.81%, rgba(0, 0, 0, 0.55) 75.52%, rgba(0, 0, 0, 0.65) 100%)',
    },
    placementAdsLabel: {
      ...placementAdsLabel,
      color: '#FFFFFF !important',
      background: 'transparent !important',
      position: 'absolute',
      left: '5%',
      top: '90%',
    },
    adInfoLabel: {
      color: '#00AECD',
      position: 'absolute',
      right: '5%',
      top: '90%',
    },
    playIconContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  };
  return styles;
};
